const TradeList = () => import(/* webpackChunkName: 'trades' */ 'wap/views/trade/List')
const TradeDetail = () => import(/* webpackChunkName: 'trades' */ 'wap/views/trade/Detail')

const title = 'Transactions | MSport'

const routes = [
  // 交易详情页
  {
    path: '/trades/details/:tradeId',
    name: 'tradeDetails',
    component: TradeDetail,
    meta: {
      hideHeader: true,
      title,
      enableTheme: true
    }
  },
  {
    path: '/trades/history',
    name: 'tradeBefore',
    component: TradeList,
    props: () => ({ isBefore: true }),
    meta: {
      title,
      enableTheme: true
    }
  },
  {
    path: '/trades',
    name: 'tradeList',
    component: TradeList,
    meta: {
      title,
      enableTheme: true
    }
  }
]

export default routes
